'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShiftCard;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _styles = require('./styles');

var styles = _interopRequireWildcard(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: make this component a *lot* more unopinionated.  Pass in the props required,
// rather than pulling from defined locations.
function getLocaled(m) {
  return m.calendar(null, {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    lastWeek: '[last] dddd',
    nextWeek: 'dddd',
    sameElse: 'L'
  });
}

function buildTimes(props) {
  var _props$schedule = props.schedule,
      start = _props$schedule.start,
      finish = _props$schedule.finish;


  if (!start || !finish) {
    return {};
  }

  var startMoment = (0, _moment2.default)(start * 1000);
  var finishMoment = (0, _moment2.default)(finish * 1000);

  return {
    startTime: startMoment.isValid() ? startMoment.format('h:mm a') : '--:--',
    startDate: startMoment.isValid() ? getLocaled(startMoment) : '',
    finishTime: finishMoment.isValid() ? finishMoment.format('h:mm a') : '--:--',
    finishDate: finishMoment.isValid() ? getLocaled(finishMoment) : ''
  };
}

function validShift(schedule, team) {
  return schedule.start && schedule.finish && team.name && team.color;
}

function ShiftCard(props) {
  /** @type {Object} args the props needed to collate the shift card information */
  var team = props.team,
      schedule = props.schedule,
      shiftDetail = props.shiftDetail;


  var times = buildTimes(props);
  if (validShift(schedule, team)) {
    return _react2.default.createElement(
      'div',
      { className: styles.shiftCard },
      _react2.default.createElement('div', {
        className: styles.color,
        style: {
          backgroundColor: team.color
        }
      }),
      _react2.default.createElement(
        'div',
        { className: styles.team },
        _react2.default.createElement(
          'p',
          { className: styles.teamName },
          team.name
        ),
        _react2.default.createElement(
          'p',
          { className: styles.teamDetails },
          shiftDetail.name
        )
      ),
      _react2.default.createElement(
        'div',
        { className: styles.details },
        // conditionally show the date of the shift
        _react2.default.createElement(
          'div',
          { className: styles.detailsRow },
          _react2.default.createElement(
            'div',
            { className: styles.detailsCol },
            _react2.default.createElement(
              'p',
              { className: styles.detailsLabel },
              'Start'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.detailsTime },
              times.startTime
            ),
            _react2.default.createElement(
              'p',
              { className: styles.detailsTime },
              times.startDate
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.detailsCol },
            _react2.default.createElement(
              'p',
              { className: styles.detailsLabel },
              'Finish'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.detailsTime },
              times.finishTime
            ),
            _react2.default.createElement(
              'p',
              { className: styles.detailsTime },
              times.finishDate
            )
          )
        )
      )
    );
  }

  // return null if no shift info, https://github.com/TandaHQ/tanda-components/pull/13
  return null;
}

ShiftCard.propTypes = {
  schedule: _propTypes2.default.shape({
    start: _propTypes2.default.number,
    finish: _propTypes2.default.number
  }).isRequired,
  team: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    color: _propTypes2.default.string
  }).isRequired,
  shiftDetail: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/ShiftCard/index.js
// module id = 1606
// module chunks = 0